import { IPrice } from '../../../../../shared/i18n/price/IPrice';
import { parsePrice } from '../../../../../shared/i18n/price/utils/parsePrice';
import { IBooking } from '../IBooking';

export function getOriginalGrandTotalPrice(originalBooking: IBooking): IPrice {
	return parsePrice(originalBooking.grandTotal);
}
